import { gsap } from 'gsap';
import { stopAudio } from './audio';
import { isMobileDevice } from './global';
import bonusTransitionMobile from '@src/assets/rive/crazy_transition_mob.riv';
import bonusTransitionDesktop from '@src/assets/rive/crazy_transition.riv';
import winAnimation from '../assets/rive/ccc_wins.riv';
import topSlotAnimation from '../assets/rive/crazy_top_slot.riv';
import crazyBallSpinAnimation from '../assets/rive/crazy_ballspin.riv';
import crazyCashReelsAnimation from '../assets/rive/crazy_cash_reels.riv';
import wheelOfFotune from '../assets/rive/crazy_bonus_wheel.riv';

export const RIVE_ANIMATIONS = {
    BONUS_TRANSITION: isMobileDevice ? bonusTransitionMobile : bonusTransitionDesktop,
    WIN: winAnimation,
    BALL_SPIN: crazyBallSpinAnimation,
    TOP_SLOT: topSlotAnimation,
    CASH_REELS: crazyCashReelsAnimation,
    WHEEL_OF_FORTUNE: wheelOfFotune
};

gsap.registerEffect({
    name: 'counter',
    extendTimeline: true,
    defaults: {
        end: 0,
        duration: 0.3,
        ease: 'power4.easeOut'
    },
    effect: (targets, config) => {
        const format = value => value.toFixed(config?.countDecimals);

        targets.forEach(element => {
            return gsap.to(element, {
                ...config,
                val: config.end,
                innerHTML: 0, // Initial value
                onStart: function () {
                    element.innerHTML = 0;
                },
                onUpdate: function () {
                    const progress = this.progress();
                    const currentVal = 0 + progress * (config.end - 0); // Calculate current value
                    element.innerHTML = format(currentVal);
                },
                onComplete: function () {
                    stopAudio(config?.counterSound, { fade: true, duration: 100 });
                }
            });
        });
    }
});

export const changeValueOfAnimationText = (artBoard, textRunName, value) => {
    const textRunFill = artBoard.textRun(textRunName); // Query by the text run name
    if (textRunFill) {
        textRunFill.text = value.toString();
    } else {
        console.warn(`Can't find textRun '${textRunName}' of artboard ${artBoard.name}. Value: ${value}`);
    }
};

export const setAnimationParamValues = (animation, stateMachineName, params = {}) => {
    const inputs = animation.stateMachineInputs(stateMachineName);

    inputs.forEach(input => {
        if (params[input.name]) {
            input.value = params[input.name];
        }
    });
};

export const getAnimationParams = (animation, stateMachineName, names = []) => {
    const inputs = animation?.stateMachineInputs(stateMachineName);

    if (inputs) {
        return inputs.reduce((acc, input) => {
            if (names.includes(input.name)) {
                acc[input.name] = input;
            }
            return acc;
        }, {});
    } else {
        return false;
    }
};

export const getPrefixText = multiplier => (multiplier === 'DOUBLE' || multiplier === 'TRIPLE' ? '' : '×');

export const TYPE_OF_WIN = {
    DEFAULT: 'DEFAULT',
    BIG: 'BIG',
    SUPER: 'SUPER',
    EPIC: 'EPIC',
    MEGA: 'MEGA'
};

export const getTypeOfWin = multiplier => {
    if (multiplier >= 1000) {
        return TYPE_OF_WIN.MEGA;
    }
    if (multiplier >= 100) {
        return TYPE_OF_WIN.EPIC;
    }
    if (multiplier >= 50) {
        return TYPE_OF_WIN.SUPER;
    }
    if (multiplier >= 10) {
        return TYPE_OF_WIN.BIG;
    }

    return TYPE_OF_WIN.DEFAULT;
};

export const ANIMATION_ORDER = [
    TYPE_OF_WIN.DEFAULT,
    TYPE_OF_WIN.BIG,
    TYPE_OF_WIN.SUPER,
    TYPE_OF_WIN.EPIC,
    TYPE_OF_WIN.MEGA
];
